import invariant from 'tiny-invariant';
import type { PaintColour } from '@modules/project/api';
import { getPaintColours } from '@modules/project/api';
import type { LoaderFunction } from '@remix-run/node';

export const loader: LoaderFunction = async ({
    request,
    context,
}): Promise<PaintColour[]> => {
    const url = new URL(request.url);
    const link = url.searchParams.get('link');
    if (!link) {
        invariant(link, 'link is required.');
    }

    return await getPaintColours({ ...context, link });
};

export const QUERY_PAINT_COLOURS = '/remix-api/paint-picker/get-paint-colours';
